"use strict";
var numberSelectInputs = document.querySelectorAll(".gf-number-stepper input");
// Check for any Number Select fields
if (numberSelectInputs.length > 0) {
    for (var i = 0; i < numberSelectInputs.length; i++) {
        var currentInput = numberSelectInputs[i];
        // prepare min, max, default values
        currentInput.min = currentInput.min ? parseInt(currentInput.min) : 0;
        currentInput.max = currentInput.max ? parseInt(currentInput.max) : 999999999;
        currentInput.defaultValue = determineDefaultValue(currentInput);
        // Decrement Button
        var buttonDecrement = document.createElement("button");
        buttonDecrement.classList.add("js-decrement-number");
        currentInput.parentNode.appendChild(buttonDecrement);
        // add event listener
        buttonDecrement.addEventListener("click", function (event) {
            registerEventListener(event, 'decrement');
        });
        // Increment Button
        var buttonIncrement = document.createElement("button");
        buttonIncrement.classList.add("js-increment-number");
        currentInput.parentNode.appendChild(buttonIncrement);
        // add event listener
        buttonIncrement.addEventListener("click", function (event) {
            registerEventListener(event, 'increment');
        });
        // On input value change, add / remove class for disabled style
        currentInput.addEventListener("change", function (event) {
            // get buttons relevant to the field was changed
            var buttonDecrementing = event.target.parentNode.querySelector('.js-decrement-number');
            var buttonIncrementing = event.target.parentNode.querySelector('.js-increment-number');
            if (event.target.value === event.target.min) {
                buttonDecrementing.classList.add("js-decrement-number--disabled");
            }
            else if (event.target.value === event.target.max) {
                buttonIncrementing.classList.add("js-increment-number--disabled");
            }
            else {
                buttonDecrementing.classList.remove("js-decrement-number--disabled");
                buttonIncrementing.classList.remove("js-increment-number--disabled");
            }
        });
        // to initialize buttons possible disabling if having boundary values
        currentInput.dispatchEvent(getChangeEvent());
    }
}
/**
 * Registers event listener for button
 * @param event
 * @param incrementOrDecrement
 */
function registerEventListener(event, incrementOrDecrement) {
    event.preventDefault();
    var input = event.target.parentNode.querySelector('input[type=number]');
    var value = parseInt(input.value);
    if (incrementOrDecrement === 'increment') {
        if (value < input.max) {
            value++;
            input.value = value;
        }
    }
    else if (incrementOrDecrement === 'decrement') {
        if (value > input.min) {
            value--;
            input.value = value;
        }
    }
    input.dispatchEvent(getChangeEvent());
}
/**
 * Determines input's default value.
 * Takes min & max values as taking precedence over defaulValue, if the latter one is outside of the min/max bundary.
 * @param inputField
 * @returns {number|*}
 */
function determineDefaultValue(inputField) {
    var defaultValue = inputField.defaultValue ? parseInt(inputField.defaultValue) : null;
    if (defaultValue) {
        if (defaultValue > inputField.max) {
            return inputField.max;
        }
        if (defaultValue < inputField.min) {
            return inputField.min;
        }
        return defaultValue;
    }
    // return min value
    return inputField.min;
}
/**
 * Gets change event, working cross-browser
 * @returns {Event}
 */
function getChangeEvent() {
    var eventChange;
    if (typeof (Event) === 'function') {
        eventChange = new Event("change");
    }
    else {
        // IE 11 fallback
        eventChange = document.createEvent('Event');
        eventChange.initEvent("change", true, true);
    }
    return eventChange;
}
